module.exports = __webpack_public_path__ + "static/haregon-87965c35d57436935a715333c420268a.webp";